import { IThunkApi } from 'shared/types/redux';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { logOut } from '@cian/auth';
import { removeOpenModalFromUrl } from 'shared/utils/url';

export const logoutUser = createAsyncThunk<void, void, IThunkApi>('logout/logoutUser', async (_, _thunkApi) => {
  const { extra } = _thunkApi;

  const logoutUrl =
    extra.config.get<string>('b2b-marketing-frontend.logOutBaseUrl') || 'https://www.master.dev3.cian.ru';

  try {
    await logOut(logoutUrl);

    removeOpenModalFromUrl();
    window.location.reload();
  } catch (e) {
    extra.logger.error(e);
  }
});
